import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ActiveRole = 'client' | 'pro' | 'org';

interface DashboardStore {
  isAvailable: boolean;
  isSpecialist: boolean;
  specialistId: string | null;
  activeSection: string;
  mobileMenuOpen: boolean;
  activeRole: ActiveRole;
  setIsAvailable: (v: boolean) => void;
  setIsSpecialist: (v: boolean, id?: string) => void;
  setActiveSection: (section: string) => void;
  setMobileMenuOpen: (v: boolean) => void;
  setActiveRole: (role: ActiveRole) => void;
}

export const useDashboardStore = create<DashboardStore>()(
  persist(
    (set) => ({
      isAvailable: true,
      isSpecialist: false,
      specialistId: null,
      activeSection: '',
      mobileMenuOpen: false,
      activeRole: 'client',
      setIsAvailable: (isAvailable) => set({ isAvailable }),
      setIsSpecialist: (isSpecialist, id) => set({ isSpecialist, specialistId: id ?? null }),
      setActiveSection: (activeSection) => set({ activeSection }),
      setMobileMenuOpen: (mobileMenuOpen) => set({ mobileMenuOpen }),
      setActiveRole: (activeRole) => set({ activeRole }),
    }),
    {
      name: 'dashboard-store',
      partialize: (state) => ({
        isAvailable: state.isAvailable,
        activeRole: state.activeRole,
      }),
    }
  )
);
